import React from 'react';
import { CheckCircle, XCircle, AlertCircle, Info, X } from 'lucide-react';

export type NotificationType = 'success' | 'error' | 'warning' | 'info';

interface NotificationBannerProps {
  type: NotificationType;
  message: string;
  onClose?: () => void;
  autoDismiss?: boolean;
  dismissAfter?: number;
}

export const NotificationBanner: React.FC<NotificationBannerProps> = ({
  type,
  message,
  onClose,
}) => {
  const config = {
    success: {
      icon: CheckCircle,
      bgColor: 'tw-bg-green-50',
      borderColor: 'tw-border-green-200',
      textColor: 'tw-text-green-800',
      iconColor: 'tw-text-green-600',
    },
    error: {
      icon: XCircle,
      bgColor: 'tw-bg-red-50',
      borderColor: 'tw-border-red-200',
      textColor: 'tw-text-red-800',
      iconColor: 'tw-text-red-600',
    },
    warning: {
      icon: AlertCircle,
      bgColor: 'tw-bg-yellow-50',
      borderColor: 'tw-border-yellow-200',
      textColor: 'tw-text-yellow-800',
      iconColor: 'tw-text-yellow-600',
    },
    info: {
      icon: Info,
      bgColor: 'tw-bg-affinicar-lighter',
      borderColor: 'tw-border-affinicar-light',
      textColor: 'tw-text-affinicar-dark',
      iconColor: 'tw-text-affinicar-primary',
    },
  };

  const { icon: Icon, bgColor, borderColor, textColor, iconColor } = config[type];

  return (
    <div
      className={`tw-flex tw-items-start tw-gap-3 tw-p-4 tw-border tw-rounded-lg ${bgColor} ${borderColor}`}
      role="alert"
    >
      <Icon className={`tw-w-5 tw-h-5 tw-flex-shrink-0 tw-mt-0.5 ${iconColor}`} />
      <p className={`tw-text-sm tw-flex-1 tw-mb-0 ${textColor}`}>{message}</p>
      {onClose && (
        <button
          type="button"
          onClick={onClose}
          className={`tw-flex-shrink-0 tw-text-gray-400 hover:tw-text-gray-600 tw-transition-colors`}
          aria-label="Fermer"
        >
          <X className="tw-w-5 tw-h-5" />
        </button>
      )}
    </div>
  );
};
